import React from 'react';
import PropTypes from 'prop-types';
import Flex from 'components/common/Flex';
import { Link } from 'react-router-dom';
import { Col, Button, Tooltip, OverlayTrigger } from 'react-bootstrap';
import ListingImages from './ListingImages';
import Moment from 'react-moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  MAKE_AN_OFFER,
  TOTAL_ASKING_PRICE,
  ASKING_PRICE_PER_HECTARE
} from 'helpers/constant';

const ListingGridItem = ({ listing, onDelete, myListingMode, ...rest }) => {
  const { id, title, price, images, pricingOption, createdAt, createdByUser } =
    listing;
  return (
    <Col className="mb-4" {...rest}>
      <Flex
        direction="column"
        justifyContent="between"
        className="border rounded-1 h-100 pb-3"
      >
        <div className="overflow-hidden h-100">
          <ListingImages images={images?.items} layout="grid" />
          <div className="p-3">
            <h4 className="fs-9">
              <Link className="text-1100" to={`/listings/${id}`}>
                {title}
              </Link>
            </h4>
            <p className="fs-10 mb-3">
              <Link to="#!" className="text-500"></Link>
            </p>
            <h5 className="fs-md-7 text-warning mb-0 d-flex align-items-center mb-3">
              {pricingOption === MAKE_AN_OFFER ? 'Make an offer' : `$${price}`}
              {pricingOption === TOTAL_ASKING_PRICE && <> per year</>}
              {pricingOption === ASKING_PRICE_PER_HECTARE && (
                <> per hectare per year</>
              )}
            </h5>
            <p className="fs-10 mb-1">
              <Moment fromNow utc local>
                {createdAt}
              </Moment>{' '}
              {!myListingMode &&
                `by ${createdByUser.firstName} ${createdByUser.lastName}`}
            </p>
            <p className="fs-10 mb-1"></p>
          </div>
        </div>
        {myListingMode && (
          <Flex alignItems="center" className="px-3">
            <div className="flex-1"></div>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip style={{ position: 'fixed' }}>Edit</Tooltip>}
            >
              <Button
                variant="falcon-default"
                size="sm"
                className="me-2"
                onClick={() => {}}
              >
                <FontAwesomeIcon icon="edit" />
              </Button>
            </OverlayTrigger>
            <OverlayTrigger
              placement="top"
              overlay={<Tooltip style={{ position: 'fixed' }}>Delete</Tooltip>}
            >
              <Button variant="falcon-default" size="sm" onClick={onDelete}>
                <FontAwesomeIcon icon="trash" />
              </Button>
            </OverlayTrigger>
          </Flex>
        )}
      </Flex>
    </Col>
  );
};

ListingGridItem.propTypes = {
  listing: PropTypes.object.isRequired,
  onDelete: PropTypes.func,
  myListingMode: PropTypes.bool
};

export default ListingGridItem;
